import { z } from 'zod';
import { PhoneNumberCapabilityChannel } from './channel.js';
import { PhoneNumberCapabilityDirection } from './direction.js';
import { PhoneNumberWebhookType } from './webhookType.js';
import { CommunicationVendor } from '../communicationVendorAccount/index.js';
/** One thing a configured phone number can do, with the vendor that manages it. */
export const PhoneNumberCapabilitySchema = z.object({
    id: z.uuid(),
    created: z.iso.datetime(),
    updated: z.iso.datetime(),
    phoneNumberId: z.uuid(),
    channel: z.enum(PhoneNumberCapabilityChannel),
    direction: z.enum(PhoneNumberCapabilityDirection),
    managingVendorAccountId: z.uuid(),
    webhookType: z.enum(PhoneNumberWebhookType).nullable(),
    vendor: z.enum(CommunicationVendor),
});
//# sourceMappingURL=phoneNumberCapability.js.map